module.exports = __webpack_public_path__ + "static/media/SCG ico.48bee516.png";